<template>
  <div class="row">
    <div class="col-12" v-if="selectedCharacteristics.length > 0">
      <p class="text-small text-primary mb-2 font-weight-bold">
        {{ trans("courses.multicircle_exercise.step_2") }}
      </p>
      <h4 class="text-primary mb-4">{{ roles[currentRole] }}</h4>
      <p>{{ trans("courses.multicircle_exercise.select_characteristics") }}</p>
      <div class="row mx-0">
        <div
          class="col-6 col-md-4 px-1 mb-2"
          v-for="characteristic in characteristics"
          :key="characteristic.id"
        >
          <b-card
            class="characteristic-card text-center"
            :class="isActive(currentRole, characteristic) ? 'active' : ''"
            @click="toggleCharacteristic({ roleIndex: currentRole, cId: characteristic.id })"
          >
            <p class="mb-0">{{ characteristic.name }}</p>
          </b-card>
        </div>
      </div>
    </div>
    <div class="col-12 mt-3">
      <div class="row mb-5 mb-sm-0">
        <div class="col-3">
          <b-button
            variant="link"
            v-if="currentRole !== 0"
            @click="saveSelectedCharacteristics(currentRole--)"
          >
            {{ trans("courses.multicircle_exercise.prev") }}</b-button
          >
        </div>
        <div class="col-6 d-flex justify-content-center align-items-center">
          <span>{{ `${currentRole + 1} / ${roles.length}` }}</span>
        </div>
        <div class="col-3 d-flex justify-content-end" v-if="selectedCharacteristics.length > 0">
          <b-button
            variant="secondary"
            v-if="currentRole < roles.length - 1"
            :disabled="selectedCharacteristics[currentRole].characteristics.length < 1"
            @click="saveSelectedCharacteristics(currentRole++)"
          >
            {{ trans("courses.multicircle_exercise.next") }}
          </b-button>
          <loading-button
            v-else
            :button-text="trans('courses.multicircle_exercise.next')"
            @click="saveCharacteristics"
            :disabled="selectedCharacteristics[currentRole].characteristics.length < 1 || isLoading"
            :loading="isLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import LoadingButton from "../../atoms/LoadingButton";

export default {
  name: "AddCharacteristics",
  components: { LoadingButton },
  data() {
    return {
      currentRole: 0,
      isLoading: false,
    };
  },
  methods: {
    saveSelectedCharacteristics(value) {
      this.value;
      this.scrollToTop();
    },
    scrollToTop() {
      document.getElementById("multime-modal").scrollTop = 0;
    },
    ...mapActions({
      postCharacteristics: "multime/postCharacteristics",
    }),
    ...mapMutations({
      toggleCharacteristic: "multime/toggleCharacteristic",
    }),
    isActive(roleIndex, characteristic) {
      return (
        this.selectedCharacteristics[roleIndex].characteristics.findIndex(
          (c) => c === characteristic.id
        ) !== -1
      );
    },
    async saveCharacteristics() {
      this.isLoading = true;
      await this.postCharacteristics();
      trackEvent("MulticircleExerciseStep2", this.trackingData);
      if (this.isPageExercise) {
        this.$emit("exerciseCompleted");
      }
      this.scrollToTop();
    },
  },
  computed: {
    ...mapGetters({
      roles: "multime/getSavedRoles",
      selectedCharacteristics: "multime/getSelectedCharacteristics",
      characteristics: "multime/getCharacteristicsList",
      isPageExercise: "multime/isPageExercise",
      trackingData: "multime/getTrackingData",
    }),
  },
};
</script>

<style scoped lang="scss">
.characteristic-card {
  border: 1px solid $color-dark-600;

  &:hover,
  &.active {
    cursor: pointer;
    background-color: $color-info;
    color: $color-white !important;
    border: 1px solid $color-info;
  }
}
</style>
